import React, { useState, useMemo } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import {Dialog } from '@mui/material';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import CalendarDetailsModal from './CalendarDetailsModal';
import { useAppData } from '../../../../../context/AppDataContext';

// Mapping your icons
const typeIcons = {
  1: '🗓️', // Event
  2: '📝', // Task
  3: '⏰', // Reminder
};

const priorityDots = {1 :'🔴', 2 : '🟡', 3 : '🟢'};

const localizer = momentLocalizer(moment);

// 1. Custom Event Component to show Time + Title
const CustomEvent = ({ event }) => (
  <div style={{ 
    display: 'flex', 
    alignItems: 'center', 
    gap: '4px', 
    fontSize: '11px',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  }}>
    <span>{priorityDots[event.priority]}</span>
    <span>{typeIcons[event.calendarType] || '📍'}</span>
    <strong>{moment(event.start).format('h:mm A')}</strong>
    <span style={{ marginLeft: '4px' }}>{event.title}</span>
  </div>
);

const CalendarViewComponent = () => {

  const {eventList} = useAppData();

  
  const {setSelectedEvent} = useAppData();

  const formattedEvents = useMemo(() => {
    if (!eventList) return [];
    return eventList.map(event => ({
      ...event,
      start: new Date(`${event.startDate}T${event.startTime}`),
      end: new Date(`${event.endDate}T${event.endTime}`),
    }));
  }, [eventList]);

  const handleEventClick = (event) => {
    setSelectedEvent(event);
  };


  const eventStyleGetter = (event) => {
    let bootstrapClass = "";
    if (event.calendarType === 1) bootstrapClass = "bg-primary";
    else if (event.calendarType === 2) bootstrapClass = "bg-dark";
    else if (event.calendarType === 3) bootstrapClass = "bg-success";

    return {
      className: bootstrapClass,
      style: { border: 'none' } // Removes the default calendar border
    };
  };


  const handleSelectSlot = ({ start, end, action }) => {
    // start and end are native JS Date objects
    console.log("Selected Start:", start);
    console.log("Selected End:", end);

    //setSlotInfo({ start, end });
    //setIsAddModalOpen(true);
    
    // Optional: If you want to auto-fill a form, you can pass these dates
    // to your "Add Task" component.
  };

  return (
    <div style={{ height: '85vh', padding: '20px' }}>
      <Calendar
        localizer={localizer}
        events={formattedEvents}
        startAccessor="start"
        endAccessor="end"
        style={{ height: '100%' }}
        onSelectEvent={handleEventClick}
        // 2. Map the custom component
        components={{
          event: CustomEvent
        }}
        //eventPropGetter={eventStyleGetter}

        selectable={true} 
        onSelectSlot={handleSelectSlot}
        longPressThreshold={10} // Makes it more responsive on mobile
      />
      <CalendarDetailsModal />
    </div>
  );
};

export default CalendarViewComponent;